module.exports = __webpack_public_path__ + "static/img/jadwal-skdb.b0da2b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/jadwal-skdb.jpg
// module id = yslz
// module chunks = 1